import { FileText, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";
import { PAGE_META } from "@/data/page_meta";

import { CONTACT, BUSINESS_NAME } from "@/data/site";

export default function ServiceAgreementPage() {
  useSEO(PAGE_META.serviceAgreement);

  return (
    <div className="min-h-screen bg-muted/30 pt-32 pb-24" data-testid="service-agreement-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <span className="w-14 h-14 rounded-full bg-leaf/15 flex items-center justify-center mb-6">
          <FileText className="w-7 h-7 text-leaf" />
        </span>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-navy">Residential Service Agreement</h1>

        <div className="mt-6 rounded-2xl border border-leaf/30 bg-leaf/5 p-5" data-testid="agreement-interim-note">
          <p className="text-navy">
            Our full Residential Service Agreement is being finalized with our attorney and will appear here shortly.
            In the meantime, every booking with {BUSINESS_NAME} is governed by our{" "}
            <Link to="/service-terms" className="text-leaf font-medium underline underline-offset-2">Service Terms</Link>,
            which cover cancellations, lockouts, payment, our guarantee, damage, safety, and more.
          </p>
        </div>

        <p className="mt-8 text-muted-foreground leading-relaxed">
          When you book, you'll be asked to agree to this Service Agreement. The date and time you accept are recorded
          with your booking, and a copy is included with your confirmation email for your records.
        </p>

        <div className="mt-8 rounded-2xl border border-border bg-white p-5 flex items-center gap-3">
          <Phone className="w-5 h-5 text-leaf" />
          <p className="text-sm text-navy">Questions? Call us at <a href={CONTACT.phoneHref} className="text-leaf font-medium">{CONTACT.phone}</a>.</p>
        </div>
      </div>
    </div>
  );
}
